import {combineReducers} from 'redux'
import login from '../login/loginReducers'
import organization from '../organization/organizationReducers'
import newsletter from '../newsletter/newsletterReducers'
import lawdocument from '../lawdocument/lawdocumentReducers'
import sbt from '../sbt/sbtReducers'
import sbl from '../sbl/sblReducers'
import sba from '../sba/sbaReducers'
import user from '../user/userReducers'
import newsentry from '../newsentry/newsentryReducers'
import config from '../config/configReducers'
import lawreport from '../lawreport/lawReportReducers'
import search from '../search/searchReducer'
import templates from '../templates/templatesReducer'
import eliterature from '../eliterature/eliteratureReducers'

export default combineReducers({
  login,
  organization,
  newsletter,
  lawdocument,
  sbt,
  lawreport,
  sbl,
  sba,
  config,
  search,
  user,
  newsentry,
  templates,
  eliterature
});


// WEBPACK FOOTER //
// ./src/app/reducers.js